import api from '../../services/feApi.ts';
import { ApiResponse } from "../../types/ApiResponse";
import { MenuItem, MenuData, PriceData } from '../../types/sale/menuTree';

export const MenuTreeService = {

    // ------------------------------
    // GET MENU TREE
    // ------------------------------
    getAllMenuTree: async (id: number, parentId: number | null): Promise<MenuItem[]> => {
        try {
            const response = await api.post<ApiResponse<MenuItem[]>>(
                '/Sales/list/menu/tree',
                {
                    MenuID: id,
                    ParentMenuID: parentId ?? null
                }
            );

            const result = response.data;

            if (!result.Success || result.StatusCode === 400) {
                return [];
            }

            return result.Data ?? [];

        } catch (error: any) {

            if (error.response) {
                return [];
            }

            if (error.request) {
                throw new Error("No response from server. Please check your network.");
            }

            throw new Error(error.message || "Unexpected error occurred.");
        }
    },

    // ------------------------------
    // GET ALL MENUS (simple list)
    // ------------------------------
    getAllMenu: async (): Promise<MenuData[]> => {
        try {
            const response = await api.get<ApiResponse<MenuData[]>>('/Sales/list/menus');
            return response.data.Data ?? [];
        } catch (error) {
            throw new Error('Failed to fetch Live Records');
        }
    },

    // ------------------------------
    // GET PRODUCT PRICE
    // ------------------------------
    getProductPrice: async (id: number): Promise<PriceData[]> => {
        try {
            const response = await api.post<ApiResponse<PriceData[]>>(
                '/Sales/list/prices',
                { ProductID: id }
            );

            const result = response.data;

            if (!result.Success || result.StatusCode === 400) {
                return [];
            }

            return result.Data ?? [];

        } catch (error: any) {

            if (error.response) {
                return [];
            }

            if (error.request) {
                throw new Error("No response from server. Please check your network.");
            }

            throw new Error(error.message || "Unexpected error occurred.");
        }
    }
}
